const getFilePickupCar = state => state.filePickupCar;
const getBoxPickupCar = state => state.boxPickupCar;
const getPickupList = state => state.pickupList;
const getPickupStorageMode = state => state.storageMode;

const getPickupCar = (state) => [
  ...state.filePickupCar,
  ...state.boxPickupCar,
];

export default {
  getFilePickupCar,
  getBoxPickupCar,
  getPickupList,
  getPickupCar,
  getPickupStorageMode,
};



// WEBPACK FOOTER //
// ./src/store/modules/pickup/getters.js